import React from "react";
import { Table, Divider, Input, Button, Tooltip } from "antd";
import {
  SearchOutlined,
  PlusCircleOutlined,
  EditOutlined,
  FileTextOutlined,
  FileAddOutlined,
} from "@ant-design/icons";
import {
  ServiceOfferingActions,
  StatusFilters,
  TablePages,
  TablePageSizes,
} from "../../Constants/Constants";
import { StatusSwitch } from "../Common/StatusSwitch";
import {
  defaultSort,
  getTablePagesize,
  setTablePageSize,
} from "../../Constants/Utilities";
import { BreadCrumbs } from "../Common/BreadCrumbs";

class ListServiceOffering extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      serviceOfferingData: props.serviceOfferingData,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.serviceOfferingData !== this.props.serviceOfferingData) {
      this.setState({ serviceOfferingData: this.props.serviceOfferingData });
    }
  }

  getColumns = () => [
    {
      title: "Offering Name",
      dataIndex: "offeringname",
      sorter: (a, b) => defaultSort(a.offeringname, b.offeringname),
      render: (value, record) => (
        <Button
          type="link"
          onClick={this.props.onActionClick(
            ServiceOfferingActions.view,
            record
          )}
        >
          {value}
        </Button>
      ),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      align: "center",
      render: (_, record) => (
        <div className="entity-list-actions">
          <Tooltip title="Add Service Instance">
            <FileAddOutlined
              onClick={this.props.onActionClick(
                ServiceOfferingActions.edit,
                record
              )}
            />
          </Tooltip>
        </div>
      ),
    },
  ];

  getExpandedColumns = () => [
    {
      title: "Service Name",
      dataIndex: "servicename",
      sorter: (a, b) => defaultSort(a.servicename, b.servicename),
    },
    {
      title: "Service Instance",
      dataIndex: "instancename",
      sorter: (a, b) => defaultSort(a.instancename, b.instancename),
    },
    {
      title: "Active",
      dataIndex: "status",
      align: "center",
      filters: StatusFilters,
      onFilter: (value, record) => record.status === value,
      render: StatusSwitch(this.props.onStatusChange),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      align: "center",
      render: (_, record) => (
        <div className="entity-list-actions">
          <Tooltip title="View Offering Instance">
            <FileTextOutlined
              className="entity-action"
              onClick={this.props.onActionClick(
                ServiceOfferingActions.viewInstance,
                record
              )}
            />
          </Tooltip>
          <Tooltip title="Edit Offering Instance">
            <EditOutlined
              onClick={this.props.onActionClick(
                ServiceOfferingActions.editInstance,
                record
              )}
            />
          </Tooltip>
        </div>
      ),
    },
  ];

  onSerchTextChange = (e) => {
    const text = e.target.value;
    const { serviceOfferingData } = this.props;
    if (!!text) {
      const filteredData = serviceOfferingData.filter((item) =>
        item.offeringname.toLowerCase().includes(text.toLowerCase())
      );
      this.setState({ serviceOfferingData: filteredData });
      return;
    }
    this.setState({ serviceOfferingData });
  };

  expandedRowRender = (record) => {
    const offeringRecord =
      this.state.serviceOfferingData.filter(
        (item) => item.offerid === record.offerid
      ) || [];

    return (
      <Table
        bordered={true}
        className="entity-table child-entity-table"
        columns={this.getExpandedColumns()}
        dataSource={offeringRecord[0].instanceData}
        pagination={{ pageSize: 5, size: "small" }}
      />
    );
  };

  render() {
    const { serviceOfferingData } = this.state;
    const { serviceOfferingDataLoading, onActionClick, parentBread } =
      this.props;

    return (
      <div className="entity-list-container">
        <div className="page-header-container">
          <BreadCrumbs headers={parentBread} />
        </div>
        <Divider className="divider" />
        <div className="search-add-container">
          <div className="search-container">
            <span className="search-label">Search:</span>
            <Input
              allowClear
              className="search-input"
              placeholder="Enter Offering Name"
              onChange={this.onSerchTextChange}
              suffix={<SearchOutlined style={{ fontSize: 16 }} />}
            />
          </div>
          <div className="add-container">
            <Button
              type="primary"
              icon={<PlusCircleOutlined />}
              onClick={onActionClick(ServiceOfferingActions.add, null)}
            >
              Create Offering
            </Button>
          </div>
        </div>
        <Table
          bordered
          size="small"
          columns={this.getColumns()}
          className="entity-table"
          dataSource={serviceOfferingData}
          loading={
            serviceOfferingDataLoading && {
              tip: "Fetching Service Offering list...",
            }
          }
          pagination={{
            responsive: true,
            showQuickJumper: true,
            showSizeChanger: true,
            defaultPageSize: getTablePagesize(TablePages.listServiceOffering),
            pageSizeOptions: TablePageSizes,
            onChange: (_, pageSize) =>
              setTablePageSize(TablePages.listServiceOffering, pageSize),
          }}
          expandable={{
            expandRowByClick: true,
            expandedRowRender: this.expandedRowRender,
          }}
        />
      </div>
    );
  }
}

export default ListServiceOffering;
